import phoneStep from './steps/phone'
import confirmPhoneForAuthorize from './steps/confirmPhoneForAuthorize'
import confirmPhoneForConfirmAndAuthorize from './steps/confirmPhoneForConfirmAndAuthorize'
import confirmPhoneForRegister from './steps/confirmPhoneForRegister'
import confirmPhoneForCompletedRegister from './steps/confirmPhoneForCompletedRegister'
import register from './steps/register'
import password from './steps/password'
import forgotPassword from "./steps/forgotPassword";

export default {
    components: {
        phoneStep,
        confirmPhoneForAuthorize,
        confirmPhoneForConfirmAndAuthorize,
        confirmPhoneForRegister,
        confirmPhoneForCompletedRegister,
        register,
        password,
        forgotPassword
    },
    data() {
      return {}
    },
    computed: {
        step() {
            return this.$store.getters.getStep
        },
        phone() {
            return this.$store.getters.getPhone
        }
    },
    methods: {
        resetForm() {
            this.$store.commit('setStep', 'enterPhone')
        }
    },
    mounted() {
        this.$store.commit('setSignedComponentParams', this.$Bitrix.Application.get().getSignedParams())
        this.$store.commit('setComponentName', this.$Bitrix.Application.get().getComponentName())
    },
    // language=Vue
    template: `
        <div>
            <div class="upblock__close js-upblock-close"
                 @click="resetForm"
            ></div>
            <phoneStep v-if="step === 'enterPhone'"/>
            <confirmPhoneForAuthorize v-else-if="step === 'confirmPhoneForAuthorize'"/>
            <confirmPhoneForConfirmAndAuthorize v-else-if="step === 'confirmPhoneForConfirmAndAuthorize'"/>
            <confirmPhoneForRegister v-else-if="step === 'confirmPhoneForRegister'"/>
            <confirmPhoneForCompletedRegister v-else-if="step === 'confirmPhoneForCompletedRegister'"/>
            <register v-else-if="step === 'register'"/>
            <password v-else-if="step === 'enterPassword'"/>
            <forgotPassword v-else-if="step === 'forgotPassword'"/>
        </div>
    `
}